import styled from "styled-components";
import { TextField, Grid } from "@material-ui/core";
import FormSimpleSelect from "@src/Components/Common/FormFields/FormSimpleSelect/FormSimpleSelect";

export const STTextArea = styled(TextField)`
  height: 100px;
`;

export const STFormSimpleSelect = styled(FormSimpleSelect).attrs({
  classes: {
    icon: "Icon",
  },
})`
  && {
    width: 120px;
  }
`;

export const LocationFormSimpleSelect = styled(FormSimpleSelect)`
  && {
    width: 100%;
  }
`;

export const STGrid = styled(Grid)`
  && {
    padding-top: 8px;
  }
`;
